import { BFormTextarea } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

/** Same as BFormTextarea; used where templates had b-textarea. Replace with your own EgBTextarea here. */
export const EgBTextarea = createEgBootstrapProxy("EgBTextarea", BFormTextarea);
